"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWeblabStatusFromChrome = exports.generateUuid = void 0;
var generateUuid = exports.generateUuid = function generateUuid() {
  return Math.floor(Math.random() * Date.now()).toString();
};
var getWeblabStatusFromChrome = exports.getWeblabStatusFromChrome = function getWeblabStatusFromChrome(weblabName) {
  try {
    var _window;
    var chromeContext = (_window = window) === null || _window === void 0 || (_window = _window.AACChrome) === null || _window === void 0 || (_window = _window.InternalAPI) === null || _window === void 0 ? void 0 : _window.getChromeContext();
    if (chromeContext) {
      var _chromeContext$featur;
      return (chromeContext === null || chromeContext === void 0 || (_chromeContext$featur = chromeContext.featureLaunchInfo) === null || _chromeContext$featur === void 0 || (_chromeContext$featur = _chromeContext$featur.features) === null || _chromeContext$featur === void 0 || (_chromeContext$featur = _chromeContext$featur.find(function (feature) {
        return feature.name === weblabName;
      })) === null || _chromeContext$featur === void 0 ? void 0 : _chromeContext$featur.isEnabled) || false;
    }
  } catch (ex) {
    console.error('error getting weblab', weblabName, ex);
  }
  return false;
};
//# sourceMappingURL=utils.js.map